import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './App.css';
import Loading from "./assets/images/loading.gif";
import Nav from "./components/Nav";
import Product from "./components/Product"
import { getBootstrapData, changePage, loginDirectly } from "./actions/GalleryActions";
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';

function App() {
  const [ t ] = useTranslation();

  const dispatch = useDispatch();
  const products = useSelector(({ Gallery }) => Gallery.products);
  const userActions = useSelector(({ Gallery }) => Gallery.userActions);
  const user = useSelector(({ Gallery }) => Gallery.user);
  const currentPage = useSelector(({ Gallery }) => Gallery.currentPage);
  const lastPage = useSelector(({ Gallery }) => Gallery.lastPage);
  const noItems = useSelector(({ Gallery }) => Gallery.noItems);
  const activeLoading = useSelector(({ Gallery }) => Gallery.activeLoading);
  const tokenReady = useSelector(({ Gallery }) => Gallery?.tokenReady);

  const [userInfo, setUserInfo] = useState({});
  const [userActionsState, setUserActionsState] = useState();
  const [loading, setLoading] = useState(true);
  const [noAvailableItems, setNoAvailableItems] = useState(false);

  useEffect(() => {
    dispatch(loginDirectly());
  },[dispatch])

  useEffect(() => {
    if(tokenReady) {
      dispatch(getBootstrapData());
    }
  }, [tokenReady, dispatch])

  useEffect(() => {
    setLoading(activeLoading)
    setNoAvailableItems(noItems)
  }, [activeLoading, noItems])

  useEffect(() => {
    setUserActionsState(userActions)
    setUserInfo(user)
  }, [userActions, user])

  return (
    <div className="App">
      <div className="gallery">
        <Nav />
        <div id="scrollable-list" className="list-container">
          {loading ?
            (<div className="loading">
              <img src={Loading} alt="" />
            </div>)
            : null}
          {
            noAvailableItems ? (
              <div className="no-items-notice">
                <h2>{t('empty_shirt_info')}</h2>
              </div>
            ) : null
          }
          <div className="list">
            {products.length ?
              <InfiniteScroll
                dataLength={products.length ?? 0}
                next={() => dispatch(changePage(currentPage + 1))}
                hasMore={currentPage < lastPage ? true : false}
                loader={
                  <div className="load-more">
                    <img src={Loading} alt="" />
                  </div>
                }
                scrollableTarget="scrollable-list"
              >
                {products.map((shirt) =>
                  <Product shirt={shirt} userActionsState={userActionsState} userInfo={userInfo} key={shirt.id} />
                )}
              </InfiniteScroll>
              : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
